/**
 * Os avisos da equipe que conduz o exame (E150 — GUS-150, ADR-0102 §4): o que o cliente registrou
 * na conversa dos casos. Os avisos do portal vivem em `pt-BR.portal.ts` (`portal.avisos`).
 */
export const ptBRAvisosDaEquipe = {
  eyebrow: 'O QUE OS CLIENTES REGISTRARAM',
  titulo: 'Avisos',
  subtitulo:
    'Mensagens, documentos e respostas dos clientes nos casos que a equipe conduz, do mais recente para o mais antigo.',
  menu: 'Avisos',
  naoLidosNoMenu: '{n} avisos sem ler',
  contadorNaoVistos: '{n} sem ler',
  contadorTudoLido: 'Tudo lido',
  tipoMensagemDoCliente: 'Mensagem do cliente',
  tipoComplementoRecebido: 'Documento complementar recebido',
  tipoPedidoRespondido: 'Pedido respondido',
  tipoIndefinido: 'Movimentação no caso',
  detalheComCcb: 'Caso {caso} · CCB {ccb}',
  detalheDoCaso: 'Caso {caso}',
  detalheComMais: '{base} · {mais}',
  marcarVisto: 'Marcar como lido',
  marcado: 'Lido',
  marcarErro: 'Não foi possível marcar como lido. Tente de novo.',
  abrirCaso: 'Abrir a conversa',
  erroCarregar: 'Não foi possível carregar os avisos. Recarregue a página.',
  vazioTitulo: 'Nenhum aviso por enquanto',
  vazioTexto:
    'Quando um cliente escrever na conversa, enviar um documento complementar ou responder a um pedido, o aviso aparece aqui.',
} as const;
